<template>
    <h1 v-bind="$attrs" :on="$listeners" />
</template>
<script>
export default {
    name: 'blank-field',
};
</script>
